import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Divider, Space } from "antd";

import { BaseTable, Header, Nav, HamburgerMenu } from "./components";
import {
  loginUserCheck,
  logoutUser,
  usersFetch,
  userDeleteById,
} from "../redux/actions";

import "../static/scss/admin/index.scss";

class Admin extends Component {
  constructor() {
    super();
    this.state = {
      toggleMenu: false,
      columns: [
        {
          title: "User ID",
          dataIndex: "user_id",
          key: "user_id",
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          render: (_, record) => `${record.firstname} ${record.lastname}`,
        },
        {
          title: "Rank",
          dataIndex: "rank",
          key: "rank",
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          render: (text) =>
            text === 0 ? (
              <span style={{ color: "red" }}>Unregister</span>
            ) : (
              <span style={{ color: "green" }}>Registered</span>
            ),
        },
        {
          title: "Created Date",
          dataIndex: "created_date",
          key: "created_date",
          render: (text) => {
            const d = new Date(Number(text));
            const date =
              d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            return date;
          },
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <Space size="middle" className="table-action">
              <Button
                type="primary"
                className="btn-edit"
                onClick={() => {
                    window.location = `/admin/edituser?id=${record.id}`
                  }
                }
              >
                แก้ไข
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                danger
                onClick={() =>
                  this._onDelete(`${record.firstname} ${record.lastname}`, record.id)
                }
              >
                ลบ
              </Button>
            </Space>
          ),
        },
      ]
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    this.props.usersFetch();
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onDelete(name, id) {
    if (window.confirm(`Confirm to delete "${name}"`)) {
      this.props.userDeleteById(id);
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    else
      return (
        <div>
          <Header name={this.props.user} logout={() => this._handleLogout()} />
          <div className="admin-users">
            <Nav active="users" />
            <div
              className={this.state.toggleMenu ? "content moveover" : "content"}
            >
              <div className="content-inner">
                <HamburgerMenu onClick={() => this._handleMenu()} />
                <div className="title">
                  <h2>ลูกค้า</h2>
                  <div className="btn-adduser">
                    <Link to="/admin/adduser" className="add-user">
                      เพิ่มลูกค้าใหม่
                    </Link>
                  </div>
                </div>
                <div className="info">
                  <BaseTable
                    columns={this.state.columns}
                    datas={this.props.users ? this.props.users : []}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
}

const mapStateToProps = ({ auth, user }) => {
  return {
    user: auth.user,
    users: user.users,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  usersFetch,
  userDeleteById,
})(Admin);
